export default "__VITE_ASSET__DLY9HO9T__"